"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

type LogoutButtonProps = {
  locale: string;
};

// Render a logout button that clears the auth session and redirects to login.
export function LogoutButton({ locale }: LogoutButtonProps) {
  const router = useRouter();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Call the logout endpoint and navigate back to the locale login page.
  async function handleLogout() {
    setIsSubmitting(true);

    try {
      await fetch("/api/auth/logout", {
        method: "POST",
      });
    } finally {
      router.push(`/${locale}/login`);
      router.refresh();
      setIsSubmitting(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleLogout}
      disabled={isSubmitting}
      className="inline-flex rounded-full bg-[linear-gradient(135deg,#12356d,#2563eb)] px-5 py-3 text-sm font-semibold text-white shadow-md shadow-blue-950/15 transition-colors hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-75"
    >
      {isSubmitting ? "Saindo..." : "Sair"}
    </button>
  );
}
